module.exports = __webpack_public_path__ + "static/media/19.acb36a47.mp4";